export default __webpack_public_path__ + "static/media/ayvensFavicon.f74f51fc.svg";